import { Box, Button } from '@mui/material'
import React from 'react'
import NoHcsLinked from '../components/Common/noHcsLinked/NoHcsLinked'
import ErrorNotFound from '../components/Common/errorNotFound/ErrorNotFound'
import { RouterErrorProps } from './_props'
import RouterOutsideContainer from './RouterOutsideContainer'

const RouterError: React.FC<RouterErrorProps> = ({ hasNoHcsLinkedError = false }) => (
    <RouterOutsideContainer>
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1.5rem',
                alignItems: 'center',
            }}
        >
            {hasNoHcsLinkedError ? <NoHcsLinked /> : <ErrorNotFound />}
            {!hasNoHcsLinkedError && (
                <Button
                    onClick={() => {
                        window.location.href = '/'
                    }}
                    variant="contained"
                    disableElevation
                    fullWidth
                >
                    Retour à l'accueil
                </Button>
            )}
        </Box>
    </RouterOutsideContainer>
)

export default RouterError
